export default __webpack_public_path__ + "static/media/Powered-by-FAC_web.797b6aff.jpg";